<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="sec-11">
<h1 class="ct" id="pz11-1"><a href="#/contents#toc1" id="con1"><i>Acknowledgments</i></a> </h1>
<p class="noind" id="pz11-2"><span class="dcap"><b>T</b></span>o my Proverbs 31 Ministries sisters (and one brother!), especially President Lysa TerKeurst: Serving God with you is my favorite thing to do! I love you all.</p>
<p id="pz11-4">To agent Esther Fedorkevich: Thank you for your encouragement to put together this idea about scattering kindness.</p>
<p id="pz11-5">To my Harper Collins Christian family: Sandy Vander Zicht, Tom Dean, Robin Phillips, John Raymond, TJ Rathbun, and Greg Clouse. Thank you for all you do to get my projects from scribbles on a legal pad to a book and video Bible study in the hands of a woman who needs it. You all are so gifted and gracious.</p>
<p id="pz11-6">To Lori Vandenbosch: Thanks for helping my words to make sense and to make a difference.</p>
<p id="pz11-7">To my prayer wall—four faith-filled friends who daily pound heaven’s doors for my sake: Kim Cordes, Sharon Glasgow, Mary Steinke, and Lindsey Feldpausch. I love you all.</p>
<p id="pz11-8">To my husband, Todd, and kids Kenna, Mitchell, and Spencer: Being a family with you all is a delightful mixture of chaos and love.</p>
<p id="pz11-9">To my Lord and Savior Jesus Christ: For dying on the cross for me, purchasing my way to heaven. Indescribable.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter03.vue?618527eb